import { useNavigate, useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";
import { MdDashboardCustomize } from "react-icons/md";
import { TbReport } from "react-icons/tb";
import { FaUserAlt, FaComments } from "react-icons/fa";
import { FaCodeCompare, FaFlagCheckered, FaUsers } from "react-icons/fa6";
import { useProfile } from "../../api/profileApi";
import { PLANS, normalizePlan } from "../../constants/plans";
import logo from "../../assets/logos/DITTRIUM_FullLogo_Coloured.svg";
const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();
  const { data: profileData } = useProfile();
  const userPlan = normalizePlan(profileData?.plan);
  const isPlusOrPro = userPlan === PLANS.PLUS || userPlan === PLANS.PROFESSIONAL;
  const isPro = userPlan === PLANS.PROFESSIONAL;

  const itemsById = {
    dashboard: { key: "/", icon: <MdDashboardCustomize className="text-2xl" />, label: "Dashboard" },
    reports: { key: "/reports", icon: <TbReport className="text-2xl" />, label: "Reports" },
    rubric: { key: "/rubric-generator", icon: <FaFlagCheckered className="text-2xl" />, label: "Rubric Generator" },
    cohorts: { key: "/cohorts", icon: <FaUsers className="text-2xl" />, label: "Cohorts" },
    compare: { key: "/compare", icon: <FaCodeCompare className="text-2xl" />, label: "Compare" },
    chatbot: { key: "https://chat.dittrium.com", icon: <FaComments className="text-2xl" />, label: "Chatbot" },
    profile: { key: "/profile", icon: <FaUserAlt className="text-2xl" />, label: "Profile" },
  };

  const orderedIds = [
    "dashboard",
    "reports",
    ...(isPlusOrPro ? ["rubric"] : []),
    ...(isPro ? ["cohorts", "compare"] : []),
    ...(isPlusOrPro ? ["chatbot"] : []), 
    "profile",
  ];

  const menuItems = orderedIds.map((id) => itemsById[id]);

  const onClick = (e) => {
    const key = String(e.key || "");
    if (/^https?:\/\//i.test(key)) {
      window.open(key, "_blank", "noopener,noreferrer");
      return;
    }
    navigate(key);
  };

  return (
    <Sider
      width={200}
      className="top-0 left-0 h-full bg-primary z-40"
      theme="dark"
    >
      <div className="flex items-center justify-start h-16 pt-4 px-4">
        <img src={logo} alt="Dittrium" className="h-10 w-auto" />
      </div>
      <Menu
        mode="inline"
        onClick={onClick}
        className="!bg-transparent !border-none font-poppins"
        theme="dark"
        items={menuItems.map((item) => ({
          key: item.key,
          icon: item.icon,
          label: <span className="text-xs">{item.label}</span>,
          className: "flex items-center",
        }))}
        styles={{
          item: {
            lineHeight: "56px",
            margin: 0,
            "&:hover": {
              backgroundColor: "var(--primary-light) !important",
            },
          },
        }}
      />
      <div className="absolute bottom-4 left-4 right-4 text-center text-2xs text-gray-400">
        (c) 2026 All Rights Reserved 21ST CENTURY EDUTECH LLC
      </div>
    </Sider>
  );
};

export default Sidebar;
